module.exports = __webpack_public_path__ + "static/DSC_3325-d6cafd44448af944c3161c2df2224fbf.jpg";